"use client"; // Error components must be Client Components

import { Button } from "@/components/ui/button";
import { useEffect } from "react";

export default function Error({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	useEffect(() => {
		// Log the error to an error reporting service
		console.error(error);
	}, [error]);

	return (
		<div>
			<div className="w-full p-6">
				<img
					src="/assets/caveman.png"
					alt="caveman"
					className="mx-auto h-auto w-full max-w-[256px]"
				/>
				<div className="flex flex-col items-center gap-2">
					<h1 className="mt-6 text-center text-2xl font-bold tracking-tight text-gray-900 sm:text-4xl">
						Eyvah!
					</h1>
					<p className="text-center text-gray-500">Bir hata oluştu.</p>
					<Button type="button" onClick={() => reset()} className="mt-6">
						Tekrar Dene
					</Button>
				</div>
			</div>
		</div>
	);
}
